import i18n from '~/utils/i18n';

import { type FeatureFlagKey } from './types';

export const featureFlagMap: Record<FeatureFlagKey, string> = {
  accessPermittedSites:
    'Nutzer kann zugeordnete Standorte und Kostenstellen einsehen',
  agentChat: i18n.t(($) => $.userFeatureFlags.assistant.changedValue, {
    ns: 'masterData',
  }),
  analyticsUser: i18n.t(($) => $.userFeatureFlags.analyticsUser.changedValue, {
    ns: 'masterData',
  }),
  concreteDiary: 'Nutzer hat Zugriff auf Betontagebuch',
  concreteEditingEnabled: 'Nutzer kann Betondaten bearbeiten',
  dlnListV2: 'Nutzer hat Zugriff auf Lieferungen V2',
  lineItemDetailsEditingDisabled: 'Nutzer kann Artikeldetails nicht bearbeiten',
  manageCallOffs: i18n.t(
    ($) => $.userFeatureFlags.manageCallOffs.changedValue,
    { ns: 'masterData' },
  ),
  manageContracts: i18n.t(
    ($) => $.userFeatureFlags.manageContracts.changedValue,
    { ns: 'masterData' },
  ),
  manualInvoiceCheckingPipeline: i18n.t(
    ($) => $.userFeatureFlags.manualInvoiceCheckingPipeline.changedValue,
    { ns: 'masterData' },
  ),
  ocrEnabled: 'Nutzer kann Lieferscheine mittels OCR einlesen',
  recipientSetArrived: 'Empfänger kann das "Angekommen" Event setzen',
  showOrderAtPreview:
    'Nutzer kann Bestellreferenz in Vorschau anzeigen (mobile App)',
  userCannotSetAccepted: 'Nutzer kann das "Angenommen" Event nicht setzen',
  userCannotSetDeclined: 'Nutzer kann das "Abgelehnt" Event nicht setzen',
  userCannotSetDelivered: 'Nutzer kann das "Geliefert" Event nicht setzen',
  userMetrics: 'Nutzer kann Benutzerstatistiken einsehen',
};
